import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { bootstrapCompanyProjects, loadCompanyProjects } from "../actions";

type Project = WtdModels.Partial<
  WtdModels.Project,
  | "id"
  | "project_url"
  | "project_path"
  | "title"
  | "looking_for"
  | "occupation_type"
  | "localized_occupation_type"
  | "plain_description"
  | "published_at"
  | "published_at_from_now_in_words"
  | "support_count"
  | "supported"
  | "bookmarked"
  | "title_and_company_for_twitter_share",
  {
    image: WtdModels.Partial<WtdModels.Image, "id" | "url">;
  }
>;

export interface ProjectsState {
  projects: Project[];
  isLoaded: boolean;
}

const InitialState: ProjectsState = {
  projects: [],
  isLoaded: false,
};

const projectsReducer = withImmer(reducerWithInitialState<ProjectsState>(InitialState))
  .case(bootstrapCompanyProjects, (state, result) => {
    state.projects = result.projects;
    state.isLoaded = true;
    return state;
  })
  .case(loadCompanyProjects.done, (state, { result }) => {
    state.projects = result.projects;
    state.isLoaded = true;
    return state;
  });

export default projectsReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/projects.ts